var map = {
	"./amplify-amazon-button_5.entry.js": [
		561,
		16
	],
	"./amplify-auth-container.entry.js": [
		562,
		17
	],
	"./amplify-auth-fields_9.entry.js": [
		563,
		18
	],
	"./amplify-authenticator.entry.js": [
		564,
		5
	],
	"./amplify-button_3.entry.js": [
		565,
		19
	],
	"./amplify-chatbot.entry.js": [
		588,
		4
	],
	"./amplify-checkbox.entry.js": [
		566,
		20
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		567,
		6
	],
	"./amplify-container.entry.js": [
		568,
		21
	],
	"./amplify-federated-buttons_2.entry.js": [
		569,
		22
	],
	"./amplify-federated-sign-in.entry.js": [
		570,
		23
	],
	"./amplify-form-field_4.entry.js": [
		571,
		24
	],
	"./amplify-greetings.entry.js": [
		572,
		25
	],
	"./amplify-icon-button.entry.js": [
		573,
		26
	],
	"./amplify-icon.entry.js": [
		574,
		7
	],
	"./amplify-link.entry.js": [
		575,
		27
	],
	"./amplify-nav_2.entry.js": [
		576,
		28
	],
	"./amplify-photo-picker.entry.js": [
		577,
		29
	],
	"./amplify-picker.entry.js": [
		578,
		30
	],
	"./amplify-radio-button_3.entry.js": [
		579,
		8
	],
	"./amplify-s3-album.entry.js": [
		580,
		9
	],
	"./amplify-s3-image-picker.entry.js": [
		581,
		10
	],
	"./amplify-s3-image.entry.js": [
		582,
		11
	],
	"./amplify-s3-text-picker.entry.js": [
		583,
		12
	],
	"./amplify-s3-text.entry.js": [
		584,
		13
	],
	"./amplify-select-mfa-type.entry.js": [
		585,
		31
	],
	"./amplify-sign-in-button.entry.js": [
		586,
		14
	],
	"./amplify-tooltip.entry.js": [
		587,
		32
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 521;
module.exports = webpackAsyncContext;